import { useTranslation } from 'react-i18next';
import { PetPayForSellersScreen } from 'shared/screens/petpay/for-sellers';
import { Page } from '@web/components/page';
import { Props } from 'shared/@types';
import { withServerProps } from '@web/library/with-server-props';

export default function PetPayForSellers(props: Props) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(t('petpay.for_sellers.title'))
          .setDescription(t('petpay.for_sellers.description'))
      }
    >
      <PetPayForSellersScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
